<sas-card>
  <div class="repeat-section">
    @if (field.props?.label && field.props!.label!.length > 0) {
      <h4 class="mb-3">{{field.props!.label}}</h4>
    }
    @for(element of model[getKey(field)]; track $index){
      @if (allowCollapse) {
        <div class="repeat-section-collapsable mb-3 d-flex align-items-baseline gap-3">
          <sas-button icon="bi-x-lg"
                      placement="top"
                      text="BUTTON.REMOVE.TEXT"
                      triggers="hover"
                      type="ghost-danger"
                      [iconOnly]="true"
                      [ngbTooltip]="field.props?.['btnRemoveText'] || 'Remove'"
                      (sasOnClick)="removeSection(getKey(field), $index)" />
          <div class="flex-grow-1" ngbAccordion>
            <div ngbAccordionItem (hidden)="onSectionToggle($index, false)" (shown)="onSectionToggle($index, true)">
              <h3 class="mt-0" ngbAccordionHeader [attr.aria-level]="$index + 1">
                <button ngbAccordionButton type="button">
                  @if (titles[$index]?.length !== 0) {
                    {{ titles[$index] }}
                  }
                </button>
              </h3>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <form [formGroup]="formArray.at($index)">
                      <formly-form [fields]="getCachedFields($index)" [form]="formArray.at($index)" [model]="element" />
                    </form>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @else {
        <form [formGroup]="formArray.at($index)">
          <formly-form [fields]="getCachedFields($index)" [form]="formArray.at($index)" [model]="element" />
        </form>
        <button class="btn btn-sm btn-danger mt-3"
                type="button"
                (click)="removeSection(getKey(field), $index)">
          {{ field.props?.['btnRemoveText'] || 'Remove' }}
        </button>
        <hr>
      }
    }
    @if(!formState.readMode){
      <button class="btn btn-primary" type="button" (click)="addNew()">{{ field.props?.['btnText'] }}</button>
    }
  </div>
</sas-card>